import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "./Button";
import styles from "./Customers.module.css";
import { useState, useEffect } from "react";
import Customer from "./Customer";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [editModal, setEditModal] = useState({ show: false, props: null });

  useEffect(() => {
    try {
      getCustomers();
    } catch (error) {}
  }, []);

  const clearSearch = (el) => {
    let element = document.getElementById(el);
    element.value = "";
    handleSearchChange(element);
  };

  const getCustomers = async () => {
    const searchtext = document.getElementById("name").value;
    const textSplit = searchtext.split(" ");
    let fname = textSplit[0];
    let lname = textSplit[1] ? textSplit[1] : "";
    let ph = document.getElementById("phone").value;
    let em = document.getElementById("email").value;
    let comp = document.getElementById("company").value;
    const res = await fetch(`/api/customers?f=${fname}&l=${lname}&t=${ph}&e=${em}&c=${comp}&limit=100`);
    const data = await res.json();
    console.log(data);
    setCustomers(data);
  };

  const editCustomer = async (customer) => {
    setEditModal({ show: true, props: customer });
  };

  const handleSearchChange = (e) => {
    let theInput;
    if (e.target) {
      theInput = e.target;
    } else {
      theInput = e;
    }
    const siblingSpan = theInput.nextSibling;

    if (theInput.value.length > 0) {
      siblingSpan.classList.add(styles.show);
    } else {
      siblingSpan.classList.remove(styles.show);
    }

    const searchtext = document.getElementById("name").value;
    const textSplit = searchtext.split(" ");
    let fname = textSplit[0];
    let lname = textSplit[1] ? textSplit[1] : "";
    let ph = document.getElementById("phone").value;
    let em = document.getElementById("email").value;
    let comp = document.getElementById("company").value;
    fetch(`/api/customers?f=${fname}&l=${lname}&t=${ph}&e=${em}&c=${comp}&limit=100`, {
      method: "get",
    })
      .then((res) => res.json())
      .then((data) => {
        setCustomers(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className={styles.customers}>
      <h2>Customers</h2>
      {/* <div className={styles.searchBox}>
        <input
          type="text"
          name="search"
          id="search"
          placeholder="Search for customer"
          onChange={handleSearchChange}
        />
        <Button type="pOutline">Clear</Button>
        <CreateNewCustomerModal />
      </div> */}
      <div>
        <table className={styles.customersTable}>
          <thead>
            <tr>
              <th>
                <input type="text" name="name" id="name" placeholder="Name" onChange={handleSearchChange} />
                <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("name")}></span>
              </th>
              <th>
                <input type="text" name="company" id="company" placeholder="Company" onChange={handleSearchChange} />
                <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("company")}></span>
              </th>
              <th>
                <input type="text" name="phone" id="phone" placeholder="Phone" onChange={handleSearchChange} />
                <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("phone")}></span>
              </th>
              <th>
                <input type="text" name="email" id="email" placeholder="Email" onChange={handleSearchChange} />
                <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("email")}></span>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(customers) &&
              customers.map((cust) => {
                return (
                  <tr>
                    <td>
                      {cust.FirstName} {cust.LastName}
                    </td>
                    <td>{cust.CompanyName}</td>
                    <td>{cust.Phone}</td>
                    <td>{cust.Email}</td>
                    <td>
                      {/* <NavLink to={`/customers/` + cust.idCustomers}>
                        <Button type="primary">View / Edit</Button>
                      </NavLink> */}
                      <Button type="primary" onClick={() => editCustomer(cust)}>
                        View / Edit
                      </Button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {editModal.show && <Customer props={editModal.props} setEditModal={setEditModal} getCustomers={getCustomers} />}
    </section>
  );
}

function CreateNewCustomerModal() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
  };

  return (
    <>
      <Button type="primary" onClick={openModal}>
        <i className="fa-solid fa-plus"></i>
      </Button>
      {isOpen && (
        <div className="modal-backdrop">
          <div className={`modal-content modal-narrow ${styles.modalTop} ${styles.newCustomerModal}`}>
            <h3 className="modal-header">Add New Customer</h3>
            <form action="" className="form">
              <div className="formRow">
                <label>First Name</label>
                <input type="text" id="firstname" name="firstname" tabIndex={1} />
              </div>
              <div className="formRow">
                <label>Last Name</label>
                <input type="text" id="lastname" name="lastname" tabIndex={2} />
              </div>
              <div className="formRow">
                <label>Company</label>
                <input type="text" id="company" name="company" tabIndex={2} />
              </div>
              <div className="formRow">
                <label>E-Mail</label>
                <input type="text" id="email" name="email" tabIndex={3} />
              </div>
              <div className="formRow">
                <label>Phone</label>
                <input type="text" id="phone" name="phone" tabIndex={4} />
              </div>
              <div className="formRow">
                <label>Address 1</label>
                <input type="text" id="address1" name="address1" tabIndex={5} />
              </div>
              <div className="formRow">
                <label>Address 2</label>
                <input type="text" id="address2" name="address2" tabIndex={6} />
              </div>
              <div className="formRow">
                <label>Address 3</label>
                <input type="text" id="address3" name="address3" tabIndex={7} />
              </div>
              <div className="formRow">
                <label>City</label>
                <input type="text" id="city" name="city" tabIndex={8} />
              </div>
              <div className={styles.stateZip}>
                <div className="formRow">
                  <label>State</label>
                  <input type="text" id="state" name="state" tabIndex={9} />
                </div>
                <div className="formRow">
                  <label>Zip</label>
                  <input type="text" id="zip" name="zip" tabIndex={10} />
                </div>
              </div>

              <div className={styles.saveButtons}>
                <Button type="primary">Save</Button>
                <Button type="save" onClick={closeModal}>
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Customers;
